module.exports = __webpack_public_path__ + "img/News_item_7.1ffbce52.jpg";